/**
 * The "system user" display name for CreateUser/ModifyUser fields when null
 */
export const systemUserName = 'System';

/**
 * Message for notifying the user that an entity cannot have its status changed. This should be related to the
 * entity having isPermanent set to true.
 */
export const PERMANENT_ENTITY_DELETED_ERROR_MESSAGE = 'This record is managed by the system and cannot be deleted';
